<template>
  <div class="card">
    <div class="card-header">
      <h4 class="title"></h4>
    </div>
    <div class="row" style="padding: 0px 15px 0px">
      <div class="col-md-12">
        <label>Die Banner im Format .jpg, oder .png sollten maximal 600 Pixel breit und maximal 200 Pixel hoch sein.</label>
        <label>Die Banner-Datei sollte nicht grösser als 100 KB sein.</label>
      </div>
    </div>
    <div v-if="this.$store.state.betgameData" class="card-content">
      <form>

        <div v-for="(ad, index) in this.ads" class="row" style="margin-top: 25px;
        border: 1px solid lightgray; margin-left: 0px; margin-right: 0px">
          <div class="col-md-3" style="text-align: center; padding: 5px;">
            <img v-if="ad.image" style="max-width: 175px; max-height: 200px; border: darkgray 1px solid;" :src="buildAdPath(ad.image, 300)">
            <input :id="'imageFileInput' + ad.id" type="file" multiple :name="'uploadFieldName' + ad.id" @change="filesChange($event.target.name, $event.target.files, ad.id); fileCount = $event.target.files.length"
                   accept="image/*" class="input-file" style="display: none" hidden>
            <div style="text-align: center; margin-top: 10px; margin-bottom: 10px;">
              <button v-if="ad.image && ad.image.length > 0" class="btn btn-info btn-fill btn-wd" @click.prevent="uploadButtonClicked(ad.id)">Bild ändern</button>
              <button v-else class="btn btn-info btn-fill btn-wd" @click.prevent="uploadButtonClicked(ad.id)">Bild hochladen</button>
            </div>
          </div>
          <div class="col-md-9" style="padding: 5px;">
            <fg-input type="text"
                      label="Position"
                      placeholder="Position"
                      disabled="true"
                      readonly="true"
                      v-model="ad.positionName">
            </fg-input>
            <fg-input type="text"
                      label="Link-Text (wenn kein Bild hochgeladen wird)"
                      placeholder="Text"
                      v-model="ad.title">
            </fg-input>
            <fg-input type="text"
                      label="Link"
                      placeholder="Link"
                      v-model="ad.link">
            </fg-input>
          </div>
        </div>

        <div class="text-right" style="margin-top: 30px; margin-bottom: 30px;">
          <button type="submit" class="btn btn-info btn-fill btn-wd" @click.prevent="updateBetgame">
            Speichern
          </button>
        </div>
        <div class="clearfix"></div>
      </form>
    </div>
  </div>
</template>
<script>
  export default {
    data () {
      return {
      }
    },
    created () {
      if (!this.$store.state.betgameData) {
        this.$store.dispatch('fetchBetgame', this.$store.state.betgame).then(() => {
        })
      }
      this.$store.dispatch('fetchBetgameAds', this.$store.state.betgame).then(() => {
      })
    },
    mounted () {
    },
    computed: {
      betgameId () {
        return '' + this.$store.state.betgameData.id
      },
      ads () {
        return this.$store.state.betgameAds
      }
    },
    methods: {
      save (file, ad) {
        this.$store.dispatch('uploadBetgameAd',
          {
            file: file,
            ad: ad
          })
          .then((res) => {
            for (var i in this.$store.state.betgameAds) {
              const ad = this.$store.state.betgameAds[i]
              ad.positionName = this.getPositionName(ad.position)
              if (ad.id === parseInt(res.adid)) {
                ad.image = res.filename
              }
            }
          })
          .catch(err => {
            this.$log.debug(err)
          })
      },
      filesChange (fieldName, fileList, ad) {
        if (!fileList.length) return
        let file = fileList[0]
        let fileSizeinMB = file.size / 1024 / 1024
        if (fileSizeinMB < 10) {
          this.save(file, ad)
        }
      },
      uploadButtonClicked (id) {
        document.getElementById('imageFileInput' + id).click()
      },
      buildAdPath (icon, width) {
        return window.sessionStorage.getItem('bgbackend_apiUrl') + '/ads/' + width + '/' + icon
      },
      updateBetgame () {
        console.log('updateBetgame ad')
        for (var i in this.ads) {
          const ad = this.ads[i]
          console.log('updateBetgame ad ' + ad.id)
          this.$store.dispatch('patchBetgameAd', {
            title: ad.title,
            fk_betgame: ad.fk_betgame,
            id: ad.id,
            image: ad.image,
            link: ad.link,
            position: ad.position
          })
            .then(() => {
            })
            .catch(function (error) {
              this.$log.debug(error)
            })
            .finally(function () {
            })
        }
      }
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/BGEditAdsForm.vue